export const HOW_WE_WORK_FOR_COMPANIES = [{
  title: 'Free Consultation (Book a demo)',
  description: 'Share your goals and objectives with&nbsp;us, and we&rsquo;ll suggest a&nbsp;solution that&rsquo;s a&nbsp;perfect fit for your company.'
}, {
  title: 'Course Trial',
  description: 'We&nbsp;will conduct a&nbsp;free trial lesson for your team, allowing you to&nbsp;assess the format and quality of&nbsp;the training.'
}, {
  title: 'Employee Assessment',
  description: 'We&nbsp;will evaluate your employees&rsquo; language proficiency to&nbsp;form the most effective groups.'
}, {
  title: 'Program Launch',
  description: 'Our teachers will start the training, and you&rsquo;ll see the first results in&nbsp;just a&nbsp;few weeks.'
}];